module.exports = "<h2 class=\"page-header\">Credit Applications</h2>\n<div class=\"clear\"></div>\n<itpx-dynamic-grid [fields]=\"fields\" [url]=\"url\" [config]=\"{useDollarPrefixConvention: true}\"></itpx-dynamic-grid>"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/credit/credit.component.html
// module id = ./src/app/agora/components/account-data/credit/credit.component.html
// module chunks = main